import { PermissionState, UserInfo } from "@/shared/type/type";
import { extractPermissionStateFromUserInfo } from "@/shared/utils/utils";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: PermissionState = {
  permissions: {},
  isSuperAdmin: false,
  isCompanyAdmin: false,
  isLoaded: false,
  userId: null,
  companyId: null,
  email: null,
  isTrialUser: false,
  userExpiry: null,
};

const permissionSlice = createSlice({
  name: "permission",
  initialState,
  reducers: {
    setPermissionsFromUserInfo(state, action: PayloadAction<UserInfo>) {
      try {
        const result = extractPermissionStateFromUserInfo(action.payload);
        state.permissions = result.permissions;
        state.isSuperAdmin = result.isSuperAdmin;
        state.isCompanyAdmin = result.isCompanyAdmin;
        state.userId = result.userId;
        state.companyId = result.companyId;
        state.email = result.email;
        state.isTrialUser = result.isTrialUser;
        state.userExpiry = result.userExpiry;
        state.isLoaded = true;
      } catch {
        // If parsing fails, set safe empty state but mark as loaded
        // to prevent infinite loading states
        state.permissions = {};
        state.isSuperAdmin = false;
        state.isCompanyAdmin = false;
        state.userId = null;
        state.companyId = null;
        state.email = null;
        state.isTrialUser = false;
        state.userExpiry = null;
        state.isLoaded = true;
      }
    },

    clearPermissions(state) {
      state.permissions = {};
      state.isSuperAdmin = false;
      state.isCompanyAdmin = false;
      state.userId = null;
      state.companyId = null;
      state.email = null;
      state.isTrialUser = false;
      state.userExpiry = null;
      state.isLoaded = false;
    },
  },
});

export const { setPermissionsFromUserInfo, clearPermissions } =
  permissionSlice.actions;
export default permissionSlice.reducer;
